import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseDataService } from '../../../../core/service/base-data.service';
import {
  ManageUserReq,
  ManageUsersGroupedList,
  ManageUsersPaginated,
  PrivilegeUserLookupResponse,
  TeamStructure,
  TeamUserResponse,
  UserInformation,
} from '../models/manage-users.model';
import { BaseFilterVm } from '../../../../shared/models/filter-data.model';
import { UserTeam } from '../../../../shared/models/common-data.model';

@Injectable({
  providedIn: 'root',
})
export class ManageUsersService {
  private apiManageUserUrl = 'api/UserInformation';
  private apiManageAllUsersInformationrUrl =
    'api/UserInformation/getAllUserInformations';

  constructor(private baseDataService: BaseDataService) {}

  createUser(userInformationReq: UserInformation): Observable<any> {
    return this.baseDataService.makePostCall(
      `${this.apiManageUserUrl}`,
      userInformationReq
    );
  }

  getUsersList(baseFilterVm: BaseFilterVm) {
    return this.baseDataService.makePostCall(
      `${this.apiManageAllUsersInformationrUrl}`,
      baseFilterVm
    );
  }

  getAllUsersList(
    baseFilterVm: BaseFilterVm
  ): Observable<ManageUsersPaginated | ManageUsersGroupedList[]> {
    return this.baseDataService.makePostCall(
      `${this.apiManageAllUsersInformationrUrl}`,
      baseFilterVm
    );
  }

  deleteUser(id: string) {
    return this.baseDataService.makeDeleteCall(
      `${this.apiManageUserUrl}/${id}`
    );
  }

  checkUsernameExists(
    userId: string | null,
    userName: string
  ): Observable<boolean> {
    var params = 'userName=' + userName;

    if (userId != null) {
      params += '&userId=' + userId;
    }
    return this.baseDataService.makeGetCall(
      `${this.apiManageUserUrl}/CheckUsernameExists?${params}`
    );
  }

  checkMailExists(userId: string | null, email: string): Observable<boolean> {
    var params = 'email=' + email;

    if (userId != null) {
      params += '&userId=' + userId;
    }
    return this.baseDataService.makeGetCall(
      `${this.apiManageUserUrl}/CheckEmailExists?${params}`
    );
  }

  getUser(id: string) {
    return this.baseDataService.makeGetCall(`${this.apiManageUserUrl}/${id}`);
  }

  updateUser(userInformationReq: UserInformation) {
    return this.baseDataService.makePutCall(
      `${this.apiManageUserUrl}`,
      userInformationReq
    );
  }

  updateUserLockStatus(reqBody: any): Observable<any> {
    return this.baseDataService.makePutCall(
      `${this.apiManageUserUrl}/updateUserInformationLockStatus`,
      reqBody
    );
  }

  getUserTeamDeatils(): Observable<UserTeam> {
    return this.baseDataService.makeGetCall(
      `${this.apiManageUserUrl}/checkUserTeamAvailability`
    );
  }

  getUsersByTeamId(teamId): Observable<TeamUserResponse[]> {
    return this.baseDataService.makeGetCall(
      `${this.apiManageUserUrl}/getUsersByTeamId?teamId=${teamId}`
    );
  }

  getPrivilegeReferenceUsersLookupAsync(
    searchString: string,
    userId?: string
  ): Observable<PrivilegeUserLookupResponse[]> {
    var query = userId ? '?userId=' + userId : '';
    return this.baseDataService.makePostCall(
      `${this.apiManageUserUrl}/privilegeReferenceUsersLookupAsync${query}`,
      searchString
    );
  }
}
